import Login from '@/pages/login/login'
import Main from '@/pages/main/main'
import Overview from '@/pages/overview/overview'
import Order from '@/pages/order/order'
import OrderRanking from '@/pages/order/order-ranking'
import FormatHot from '@/pages/format/format-hot'
import FormatQuery from '@/pages/format/format-query'
import FormatManager from '@/pages/format/format-manager'
import FormatView from '@/pages/format/format-view'
import FormatEdit from '@/pages/format/format-edit'
import Operation from '@/pages/operation/operation'
import Invoices from '@/pages/invoices/invoices'
import Recharge from '@/pages/recharge/recharge'
import RechargeRecord from '@/pages/recharge/rechargeRecord'
import Shopping from '@/pages/shopping/shopping'
import Appraise from '@/pages/appraise/appraise'
import Consult from '@/pages/consult/consult'
import Activities from '@/pages/activities/activities'
import WorkSheet from '@/pages/workSheet/workSheet'

// 配置路由
let routes = [{
  path: '/',
  redirect: '/login',
  hidden: true
}, // 默认就跳转此页面
{
  path: '/login',
  name: 'Login',
  component: Login
},
{
  path: '/main',
  name: 'Main',
  component: Main,
  children: [{
    path: '',
    name: 'Overview',
    component: Overview
  },
  {
    path: 'order',
    name: 'order',
    component: Order
  },
  {
    path: 'orderRanking',
    name: 'OrderRanking',
    component: OrderRanking
  },
  {
    path: 'formatHot',
    name: 'FormatHot',
    component: FormatHot
  },
  {
    path: 'formatQuery',
    name: 'FormatQuery',
    component: FormatQuery
  },
  {
    path: 'formatManager',
    name: 'FormatManager',
    component: FormatManager
  },
  {
    path: 'formatView',
    name: 'FormatView',
    component: FormatView
  },
  {
    path: 'formatEdit',
    name: 'FormatEdit',
    component: FormatEdit
  },
  {
    path: 'operation',
    name: 'operation',
    component: Operation
  },
  {
    path: 'invoices',
    name: 'invoices',
    component: Invoices
  },
  {
    path: 'recharge',
    name: 'recharge',
    component: Recharge
  },
  {
    path: 'rechargeRecord',
    name: 'rechargeRecord',
    component: RechargeRecord
  },
  {
    path: 'appraise',
    name: 'appraise',
    component: Appraise
  },
  {
    path: 'shopping',
    name: 'shopping',
    component: Shopping
  },
  {
    path: 'consult',
    name: 'consult',
    component: Consult
  },
  {
    path: 'activities',
    name: 'activities',
    component: Activities
  },
  {
    path: 'workSheet',
    name: 'workSheet',
    component: WorkSheet
  }]
}
]
export default routes



// WEBPACK FOOTER //
// ./src/router/index.js